import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Zap } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About Us',
    path: '/about'
  }, {
    name: 'Project Gallery',
    path: '/gallery'
  }, {
    name: 'Financing',
    path: '/financing'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b border-slate-800/60 ${isScrolled ? 'bg-navy shadow-lg py-3' : 'bg-navy py-4'}`} data-id="element-61">
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between gap-6" data-id="element-62">
        {/* Logo — TEP icon + wordmark */}
        <Link to="/" className="flex items-center gap-3 group shrink-0" data-id="element-63">
          {/* TEP logo mark */}
          <video src="https://cdn.magicpatterns.com/uploads/7WxQuepNXeVvAcNAXbfhWT/kling_20260618_VIDEO_Create_a_p_561_0.mp4" autoPlay loop muted playsInline className="h-16 md:h-20 w-auto -my-3 object-contain" data-id="element-64" />
          <div className="hidden sm:flex flex-col leading-none" data-id="element-65">
            <span className="font-display font-bold text-base md:text-lg text-white tracking-tight" data-id="element-66">
              THE ELECTRICAL
            </span>
            <span className="font-display font-bold text-base md:text-lg text-white tracking-tight" data-id="element-67">
              PROFESSIONALS INC
            </span>
          </div>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-6 xl:gap-8" data-id="element-68">
          <ul className="flex items-center gap-5 xl:gap-7" data-id="element-69">
            {navLinks.map(link => <li key={link.name} data-id="element-70">
                <Link to={link.path} className={`text-sm font-semibold uppercase tracking-wide transition-colors ${location.pathname === link.path ? 'text-accent' : 'text-white hover:text-accent'}`} data-id="element-71">
                  {link.name}
                </Link>
              </li>)}
          </ul>

          <div className="flex items-center gap-5 border-l border-slate-700 pl-5 xl:pl-6" data-id="element-72">
            <a href="tel:4075040596" className="flex items-center gap-2 text-white hover:text-accent transition-colors group" data-id="element-73">
              <Phone className="w-4 h-4 text-accent" data-id="element-74" />
              <span className="text-sm font-semibold tracking-wide" data-id="element-75">
                (407) 504-0596
              </span>
            </a>
            <Link to="/quote" className="bg-accent hover:bg-accent-hover text-white px-5 py-2.5 rounded-sm text-xs font-bold uppercase tracking-wider transition-colors shadow-sm" data-id="element-76">
              Request a Free Quote
            </Link>
          </div>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden text-white p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-77">
          {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-78" /> : <Menu className="w-6 h-6" data-id="element-79" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="lg:hidden absolute top-full left-0 right-0 bg-navy border-t border-slate-800 shadow-xl" data-id="element-80">
          <div className="px-6 py-6 flex flex-col gap-6" data-id="element-81">
            <ul className="flex flex-col gap-4" data-id="element-82">
              {navLinks.map(link => <li key={link.name} data-id="element-83">
                  <Link to={link.path} className={`block text-base font-semibold uppercase tracking-wide ${location.pathname === link.path ? 'text-accent' : 'text-white'}`} data-id="element-84">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
            <div className="flex flex-col gap-4 pt-6 border-t border-slate-800" data-id="element-85">
              <a href="tel:4075040596" className="flex items-center gap-3 text-white" data-id="element-86">
                <div className="bg-slate-800 p-2 rounded-sm" data-id="element-87">
                  <Phone className="w-5 h-5 text-accent" data-id="element-88" />
                </div>
                <span className="text-lg font-semibold" data-id="element-89">(407) 504-0596</span>
              </a>
              <Link to="/quote" className="bg-accent text-white text-center px-6 py-3 rounded-sm font-bold uppercase tracking-wider text-sm" data-id="element-90">
                Request a Free Quote
              </Link>
            </div>
          </div>
        </div>}
    </header>;
}